export default __webpack_public_path__ + "static/media/3.e7e63ab2.png";